import React, { useState, useEffect, useContext } from "react";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const Help = ({ isDevMode }) => {
  //
  return (
    <>
      <Header title="FAQ" />
      <div style={{ display: "flex", flexDirection: "column", maxWidth: "1140px", margin: "0 auto", [mq[0]]: { fontSize: "1.2rem" } }}>
        <div style={{ padding: "20px", display: "flex", flexDirection: "column", flex: 1 }}>
          <div style={{ ...styles.title }}>Help</div>
          <div>
            <br />
            For help with account or order issues, please email us: <a href="mailto:support@getfullproof.com">support@getfullproof.com</a>
          </div>
        </div>
        <div style={{ height: 100 }} />
        <FAQ />
      </div>
      <Footer />
    </>
  );
};

export default Help;

const styles = {
  title: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: 20,
  },
};
